import React from 'react';
import { Flex } from 'antd';
import { coreBrandColors, spacing } from '../../../theming';
import classes from './LeftMenu.module.scss';
import '../../../App.scss';
import SideMenu from '../sideMenu/SideMenu';
import { useMedia } from '../../../hooks/useMediaQuery';

function LeftMenu({ headerHeight, closeDrawer }) {
    const { isSmallDevice } = useMedia();

    return (
        <Flex
            vertical
            style={{
                backgroundColor: coreBrandColors.blueRibbon,
                minHeight: `calc(100vh - ${headerHeight})`,
                paddingBlock: spacing[6],
                paddingInline: isSmallDevice ? spacing[4] : 28,
                width: isSmallDevice ? 300 : 240,
                boxSizing: 'border-box',
            }}
            className={classes['left-menu']}
        >
            <SideMenu closeDrawer={closeDrawer} />
        </Flex>
    );
}

export default LeftMenu;
